/**
 * Presentational component to toggle between DT and LOBBY.
 */
import { DriveEta, DirectionsWalk, PhoneIphone } from '@mui/icons-material';
import { useData } from '../../hooks/useData';

export default function DriveThruLobbyToggle(): JSX.Element {
  const { toggled, handleToggle, profile } = useData();
  const hostname = window.location.hostname.replace(/^www\./, '');
  const isAvsHostname = hostname.startsWith('avs');

  let toggles = [
    {
      icon: DirectionsWalk,
      alt: 'Lobby',
      name: 'LOBBY',
    },
    {
      icon: DriveEta,
      alt: 'Drive-thru',
      name: 'DT',
    },
    {
      icon: PhoneIphone,
      alt: 'Mobile',
      name: 'MOBILE',
    },
  ];

  // Filter toggles based on hostname and configuration
  if (profile) {
    const noDt = profile?.franchise.configuration.configuration.driveThruConfiguration == null || 
                 profile?.locations.some(loc => loc.dtConfiguration == undefined);
    const noLobby = profile?.franchise.configuration.configuration.lobbyConfiguration == null || 
                    profile?.locations.some(loc => loc.lobbyConfiguration == undefined);

    if (isAvsHostname) {
      // On 'local' hostname, only show Lobby
      toggles = [
        {
          icon: DirectionsWalk,
          alt: 'Lobby',
          name: 'LOBBY',
        },
      ];
      handleToggle('LOBBY');
    } else if (noDt && noLobby) {
      // If neither DT nor Lobby is configured, only show Lobby
      toggles = [
        {
          icon: DirectionsWalk,
          alt: 'Lobby',
          name: 'LOBBY',
        },
      ];
      handleToggle('LOBBY');
    } else if (noDt) {
      // If no DT, only show Lobby
      toggles = [
        {
          icon: DirectionsWalk,
          alt: 'Lobby',
          name: 'LOBBY',
        },
      ];
      handleToggle('LOBBY');
    } else if (noLobby) {
      // If no Lobby, only show DT
      toggles = [
        {
          icon: DriveEta,
          alt: 'Drive-thru',
          name: 'DT',
        },
      ];
      handleToggle('DT');
    }
  }

  return (
    <div className="flex justify-center gap-4">
      {toggles.map((toggle) => (
        <button
          key={toggle.name}
          onClick={() => {
            handleToggle(toggle.name as 'LOBBY' | 'DT' | 'MOBILE');
          }}
          className={`btn p-1 relative group ${
            toggled === toggle.name
              ? 'bg-white shadow-sm dark:bg-slate-700 ring-1 ring-blue-400'
              : 'bg-gray-100 dark:bg-slate-900'
          } focus:outline-none focus:ring-1 focus:ring-blue-400`}
          data-cy={`${toggle.name}-toggle`}
        >
          <toggle.icon />
          {toggle.name === 'LOBBY' && (
            <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-2 py-1 rounded bg-black text-white text-xs opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity">
              Lobby SOS
            </span>
          )}
          {toggle.name === 'DT' && (
            <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-2 py-1 rounded bg-black text-white text-xs opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity">
              DT SOS
            </span>
          )}
          {toggle.name === 'MOBILE' && (
            <span className="absolute left-1/2 -translate-x-1/2 bottom-full mb-2 px-2 py-1 rounded bg-black text-white text-xs opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity">
              Mobile SOS
            </span>
          )}
        </button>
      ))}
    </div>
  );
}